<script setup lang="ts">
    import { useApp } from "@/stores/app";

    import { Moon, Sun } from "lucide-vue-next";

    import Button from "@/components/tellscale/primitives/Button.vue";

    const app = useApp();
</script>

<template>
    <Button @click="app.toggleColorMode" size="icon" variant="outline">
        <Sun v-if="app.isLightMode"/>
        <Moon v-if="app.isDarkMode"/>
    </Button>
</template>

<style scoped lang="scss">

</style>